import React from 'react';

import { uiRoutes } from '@consumer-frontend/nc-api';
import { dateFromMessageTimestamp } from '@consumer-frontend/nc-utils';
import { Link, ListGroupItem } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/brands/netcredit/message-center.scss';
import '@consumer-bootstrap/netcredit.scss';

export type NcMessageCenterLinkPropsT = {
  messageDate: string;
  messageTitle: string;
  onClick?: () => void;
};

export type NcMessageCenterLinkT = React.FC<NcMessageCenterLinkPropsT>;

export const NcMessageCenterLink: NcMessageCenterLinkT = ({
  messageTitle,
  messageDate,
  onClick,
}) => {
  return (
    <ListGroupItem>
      <Link
        className="nc-message-center-link"
        onClick={onClick}
        to={uiRoutes.dashboard.messageDetail}
      >
        <p className="nc-message-title">{messageTitle}</p>
        <p className="nc-message-date" data-chromatic="ignore">{dateFromMessageTimestamp(messageDate)}</p>
      </Link>
    </ListGroupItem>
  );
};
